import { Box, HStack } from "@chakra-ui/react";
import { VeriTable } from "@verivest/shared-components";
import { useFlattenedInvestmentModel } from "@verivest/shared-components/src/api/hooks/models/useFlattenedInvestmentModel";
import { FlattenedInvestmentModel } from "@verivest/shared-components/src/api/models";
import { VeriSearchInput } from "@verivest/shared-components/src/components/common/VeriSearchInput";
import { Renderers } from "@verivest/shared-components/src/components/common/VeriTable/renderers";
import { VeriAccountSelect } from "@verivest/shared-components/src/components/form-controls/model-controls/VeriAccountSelect";
import { VeriOpportunitySelect } from "@verivest/shared-components/src/components/form-controls/model-controls/VeriOpportunitySelect";
import { HookFormDateRangeInput } from "@verivest/shared-components/src/components/form-controls/VeriDateRangeInput/HookFormDateRangeInput";
import { useVeriForm } from "@verivest/shared-components/src/react-hook-form";
import React from "react";
import {
  TransactionsTableHookFormFiltersData,
  TransactionsTableProps,
} from "./TransactionsTable.types";

export const TransactionsTable: React.FC<TransactionsTableProps> = ({
  category,
  manager,
  selectedFilterOpportunity,
  selectedFilterAccount,
  ...rest
}) => {
  const form = useVeriForm<TransactionsTableHookFormFiltersData>(
    selectedFilterOpportunity || selectedFilterAccount
      ? {
          defaultValues: {
            opportunity: selectedFilterOpportunity,
            account: selectedFilterAccount,
          },
        }
      : undefined,
  );
  const filterOpportunity = form.watch("opportunity");
  const filterAccount = form.watch("account");
  const searchQuery = form.watch("searchQuery");
  const dates = String(form.watch("date") || "").split(",");

  const [total, setTotal] = React.useState(0);

  const flattenedInvestmentModel = useFlattenedInvestmentModel();

  return (
    <Box {...rest}>
      <Box>
        <VeriSearchInput
          onSearchChange={(query) => form.setValue("searchQuery", query)}
          searchValue={searchQuery}
          label={"Transactions"}
          mb={4}
        />
      </Box>
      <HStack spacing={6} mb={4}>
        <VeriOpportunitySelect
          label={""}
          form={form}
          name={"opportunity"}
          usePlacement={false}
          managerId={String(manager.id)}
          isInvestedIn
        />
        <VeriAccountSelect
          label={""}
          form={form}
          name={"account"}
          usePlacement={false}
        />
        <HookFormDateRangeInput
          fromPlaceholder={"From"}
          toPlaceholder={"To"}
          label={""}
          form={form}
          name={"date"}
        />
      </HStack>
      <VeriTable
        model={flattenedInvestmentModel}
        apiUrlParams={{
          manager_id: manager.id,
          ...(category ? { transaction_categories: category } : {}),
          ...(filterOpportunity?.id
            ? { "filter[opportunity_ids]": filterOpportunity.id }
            : {}),
          ...(filterAccount?.id ? { account_id: filterAccount.id } : {}),
          ...(dates?.[0] ? { "filter[start_date]": dates[0] } : {}),
          ...(dates?.[1] ? { "filter[end_date]": dates[1] } : {}),
          ...(searchQuery ? { "filter[search]": searchQuery } : {}),
        }}
        tableProps={{ my: 0 }}
        columns={{
          transactionEffectiveDate: {
            label: "Date",
            renderer: Renderers.Date,
          },
          offeringName: {
            label: "Offering",
          },
          transactionType: {
            label: "Type",
          },
          description: {
            label: "Description",
          },
          transactionAmount: {
            label: "Amount",
            renderer: Renderers.Money,
          },
        }}
        variant={"unstyledRegular"}
        footerRecord={{
          transactionEffectiveDate: "Total",
          transactionAmount: total,
        }}
        indexIdentifier={"iD"}
        filterRecords={(result) => {
          const _result = result as FlattenedInvestmentModel;
          setTotal(_result.totalAmount || 0);
          return _result.items || [];
        }}
        apiPagination
      />
    </Box>
  );
};
